import React, { useState } from 'react'
import { MapPinIcon, PlusIcon } from '@heroicons/react/24/outline';

const Addresses = ({ addresses }) => {
  const [showAllAddresses, setShowAllAddresses] = useState(false);

  const toggleShowAllAddresses = () => {
    setShowAllAddresses(!showAllAddresses);
  };

  if (!addresses || addresses.length === 0) {
    return null;
  }

  return (
    <div className="border border-primary/50 rounded-lg p-4 flex flex-col gap-y-3 ">
      <h4 className="text-base-content font-medium">Adresse</h4>
      
      <div className="flex flex-col gap-y-3 h-auto max-h-36 overflow-y-auto">
        {/* Première adresse */}
        <div className="flex items-start gap-x-2">
          <MapPinIcon className="w-4 h-4 mt-0.5 flex-shrink-0" />
          <div className="flex-1">
            <div className="text-sm text-base-content font-medium">
              {addresses[0].street && `${addresses[0].street},`} {addresses[0].postcode}
            </div>
            <div className="text-sm text-base-content mt-0.5">
              {addresses[0].city && `${addresses[0].city},`} {addresses[0].state && `${addresses[0].state},`} {addresses[0].country}
            </div>
          </div>
        </div>

        {/* Bouton pour afficher plus d'adresses */}
        {addresses.length > 1 && !showAllAddresses && (
          <button
            onClick={toggleShowAllAddresses}
            className="text-xs text-base-content/50 hover:text-primary  transition-colors flex items-center space-x-1 cursor-pointer"
          >
            <PlusIcon className="w-3 h-3" />
            <span>Afficher {addresses.length - 1} autre{addresses.length - 1 > 1 ? 's' : ''} adresse{addresses.length - 1 > 1 ? 's' : ''}</span>
          </button>
        )}

        {/* Adresses supplémentaires */}
        {showAllAddresses && (
          <div className="space-y-2">
            {addresses.slice(1).map((address, index) => (
              <div key={index} className="flex items-start gap-x-2">
                <MapPinIcon className="w-4 h-4 text-base-content/60 mt-0.5 flex-shrink-0" />
                <div className="flex-1">
                  <div className="text-sm text-base-content font-medium">
                    {address.street}
                  </div>
                  <div className="text-sm text-base-content mt-0.5">
                    {address.postcode} {address.city}, {address.country}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Addresses
